import { createContext, useContext, useState } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [currentFilter, setCurrentFilter] = useState(null);
  const [currentSearch, setCurrentSearch] = useState(null);
   

  return (
    <FilterContext.Provider value={{ currentFilter, setCurrentFilter, currentSearch, setCurrentSearch }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => useContext(FilterContext);